import React from 'react';
import ContextPropsType from './ContextPropTypes';
import config from './config';

export default React.createContext<ContextPropsType>(config);
